import CreatorProfileTop from "../components/ProfileTop/CreatorProfileTop";
import ProfileAssets from "../components/ProfileAssets";
import AboutAuthor from "../components/AboutAithor/AboutAuthor";
import SharePage from "../components/SharePage/SharePage";

import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchCreatorProfile } from "../store/slices/creatorProfileSlice";

import { useParams } from "react-router-dom";

const CreatorProfile = () => {
  const { profileId } = useParams();
  const dispatch = useDispatch();
  const { profile, status } = useSelector(state => state.creatorProfile);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    dispatch(fetchCreatorProfile(profileId));
  }, [dispatch, profileId]);

  useEffect(() => {
    if (profile) {
      document.title = `Distortion Grids Database - ${profile.username}`;
      
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.content = `Distortion Grids Database - ${profile.username}`;
      }
    }
  }, [profile]);

  return (
    <>
      <CreatorProfileTop profile={profile || {}} status={status} />
      <ProfileAssets userId={profileId} showPurchases={false} />
      {profile?.about_me && <AboutAuthor about={profile.about_me} />}
      {/* <SharePage profileId={profileId} profile={profile}/> */}
    </>
  );
};

export default CreatorProfile;